module.exports = {
  "dof-progress": {
    "backgroundColor": "#f2f3f4"
  },
  "progress": {
    "position": "absolute",
    "backgroundColor": "#29c3ff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4312e0f4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-progress/index.vue
// module id = 469
// module chunks = 0 1